import meta from '../../package.json';

import es from '../i18n/es.json';

export * from './apiConfig';

export const I18N = {
  namespace: meta.name,
  bundles: {
    es
  }
};

export const SIGN_IN_EMAIL_PASSWORD_MODE = 'sign-in/email-and-password';
export const CHANGE_PASSWORD_MODE = 'sign-in/change-password';
export const RENEW_PASSWORD_MODE = 'sign-in/reset-password';
export const FORGOT_PASSWORD_MODE = 'sign-in/forgot-password';
export const ACTIVATION_MODE = 'sign-in/activate';
export const VERIFYING_MODE = 'sign-in/verifying';
export const COMPANY_SELECTOR = '/company-selector';
export const CLINIC_SELECTOR = '/clinic-selector';
export const USER_LOADING = '/user/loading';

export const ICONS = [];
